import React from 'react';

// local dependencies
import { icon } from './icon-bank.view';
import { iconConfig } from 'config/icon.config';

/**
 * @desc This is basically an hoc which has 'icon' view as its component, it recieves the config, sends it to 'icon' view along with the props.
 * @param {*} Component - icon view
 * @param {*} config - icon-config containing icon configurations.
 */
const getIconBank = ( Component = icon, config ) => {
    return class getIcon extends React.Component {
        constructor() {
			super();
        }

        render() {
            return (
                <Component
                    { ...this.props }
                    { ...config }
                />
            );
        }
    };
};

/**
 * @desc Renders an icon based on custom icon-config.
 */
export const iconBank = ( config = {} ) => {
    return getIconBank( icon, config );
};

/**
 * @desc Renders an icon based on icon `id` from `iconConfig` icon-config.
 * @example
 * import { Icon } from 'modules/icon-bank';
 */
export const Icon = iconBank( iconConfig );
